import moment from "moment";

const PlanManager = (app) => {
  app
    .post(
      "/plan-manager/status",
      async ({ api, assert, flash, req, res, locals }) => {
        const {
          body: { id, status },
        } = req;

        assert(status, 400, "Status is required");
        assert(id, 400, "Plan id is required");

        let bodyToSend = { id, active: status !== "unpublish" };
        if (locals.activeUser.organizationId) {
          bodyToSend = {
            ...bodyToSend,
            organizationUser: locals.activeUserToRequest._id,
          };
        }

        await api(`coach-plan-manager`, {
          method: "PUT",
          body: bodyToSend,
        });

        flash("success", `Successfully ${status}ed`);

        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    )
    .post(
      "/plan-manager/preferred",
      async ({ api, assert, flash, req, res, locals }) => {
        const {
          body: { id, preferred, plans },
        } = req;

        assert(id, 400, "Plan id is required");
        assert(plans, 400, "List of plans is required");

        if (!preferred) {
          const hasPreferred = plans.some(
            (plan) => plan.metadata?.preferred === "true"
          );

          assert(!hasPreferred, 400, "There is already a preferred plan");
        }

        let bodyToSend = { id, preferred: !preferred };
        if (locals.activeUser.organizationId) {
          bodyToSend = {
            ...bodyToSend,
            organizationUser: locals.activeUserToRequest._id,
          };
        }
        await api(`coach-plan-manager`, {
          method: "PUT",
          body: bodyToSend,
        });

        flash("success", `Successfully edited`);

        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    )
    .post(
      "/plan-manager/save",
      async ({ api, assert, flash, req, res, locals }) => {
        const { body } = req;

        if (!body.id) {
          assert(body.price, 400, "Price is required");
          assert(body.currency, 400, "Currency is required");
          assert(body.interval, 400, "Interval is required");
          if (body.type === "press") {
            assert(body.access, 400, "User access is required");
          }
        }

        if (body.type === "press") {
          assert(body.nickname, 400, "Name is required");
          assert(body.feature_1, 400, "Feature is required");
        }

        if (!body.facilikey) body.facilikey = null;
        if (!body.tax_rate) body.tax_rate = null;

        if (locals.activeUser.organizationId) {
          body.organizationUser = locals.activeUserToRequest._id;
        }

        await api(`coach-plan-manager`, {
          method: body.id ? "PUT" : "POST",
          body,
        });

        flash("success", `Successfully saved`);

        res.refreshWith(
          { modal: "", plan: "", type: "" },
          { url: "back", hash: "#_" }
        );
      }
    )
    .post(
      "/plan-manager/add-trial",
      async ({ api, assert, flash, req, res, locals }) => {
        const { body } = req;

        if (body.hasFreeTrial) {
          assert(body.trial_days, 400, "Free trial days are required");
        } else {
          body.trial_days = null;
        }

        if (locals.activeUser.organizationId) {
          body.organizationUser = locals.activeUserToRequest._id;
        }

        await api(`coach-plan-manager`, {
          method: "PUT",
          body,
        });

        flash("success", `Successfully saved`);

        res.refreshWith(
          { modal: "", plan: "", type: "" },
          { url: "back", hash: "#_" }
        );
      }
    )
    .post(
      "/plan-manager/add-minimum-term",
      async ({ api, assert, flash, req, res, locals }) => {
        const { body } = req;

        if (body.hasMinimumTerm) {
          assert(body.minimum_term, 400, "Minimum term is required");
        } else {
          body.minimum_term = null;
        }

        if (locals.activeUser.organizationId) {
          body.organizationUser = locals.activeUserToRequest._id;
        }

        console.log({ body });

        await api(`coach-plan-manager`, {
          method: "PUT",
          body,
        });

        flash("success", `Successfully saved`);

        res.refreshWith(
          { modal: "", plan: "", type: "" },
          { url: "back", hash: "#_" }
        );
      }
    )
    .post(
      "/plan-manager/create-coupon",
      async ({ api, flash, req, res, locals }) => {
        const { body } = req;
        if (body.redeem_by) {
          body.redeem_by = moment(body.redeem_by).unix();
        }
        if (locals.activeUser.organizationId) {
          body.organizationUser = locals.activeUserToRequest._id;
        }

        const couponColors = [
          ["#00B4DB", "#0083B0"],
          ["#BC4E9C", "#F80759"],
          ["#FF9068", "#FF4B1F"],
          ["#734B6D", "#42275A"],
          ["#8E2DE2", "#4A00E0"],
          ["#34E89E", "#0F3443"],
          ["#C11E38", "#741020"],
          ["#F7BA2C", "#EA5459"],
        ];

        const randomNumber = Math.floor(Math.random() * 8);
        body.colors = couponColors[randomNumber];

        await api(`stripe-coupon`, {
          method: "POST",
          body,
        });

        flash("success", "Successfully created");

        res.backDontScroll();
      }
    )
    .get(
      "/plan-manager/delete-coupon/:id",
      async ({ api, req, res, flash, locals }) => {
        const { id } = req.params;
        let query = `?id=${id}`;
        if (locals.activeUser.organizationId) {
          query += `&organizationUser=${locals.activeUserToRequest._id}`;
        }

        await api(`stripe-coupon${query}`, { method: "DELETE" });

        flash("success", "Successfully deleted");

        res.backDontScroll();
      }
    );
};

export default PlanManager;
